import inViewport from '@resources/js/helpers/inViewport';
const rootAmenitiesElement = document.querySelector('.js-amenities-section');
inViewport(rootAmenitiesElement, async () => {
    const SHOW_MORE_BTN_SELECTOR = '.js-amenities-show-more';
    const modalElement = rootAmenitiesElement.querySelector('.js-modal-target');
    const showMoreBtnElement = rootAmenitiesElement.querySelector(SHOW_MORE_BTN_SELECTOR);
    if (!modalElement || !showMoreBtnElement)
        return;
    const { default: Modal } = await import('@resources/js/ui/Modal');
    new Modal(modalElement, {
        trigger: SHOW_MORE_BTN_SELECTOR,
    });
});
